export const assets = {
  notFound: require("./notFound.png"),
  fileNotFound: require("./551334.jpg"),
  posterNotFound: require("./posterNotFound.svg"),
};
